export default __webpack_public_path__ + "static/media/Herb_Morgan.837b6fa0.jpg";